import React, { Component } from 'react';
import { postData } from '../services/api';
import store from '../store/main';
import { observer } from "mobx-react";
import {formatTime} from '../utils/formatTime';
import { sessionLocalStorage, setLocalStoregeSession } from '../utils/session-local-storage';

class Footer extends Component {

    constructor(props) {
        super(props);

        this.state = 
        {
            text: '',
            language: 'pt-BR'
        }
        
    }

    postUserText() {
        if (this.state.text && this.state.text.trim()) {
            store.messages.push({   
                text: this.state.text,
                time: formatTime(),
                sessionObject: this.state
            });
        
            const reload = sessionLocalStorage();

            if(reload){
                postData({
                    text: reload,
                    id: store.sessionId,
                    language: this.state.language
                });
    
            } else {
                postData({
                    text: this.state.text,
                    id: store.sessionId,
                    language: this.state.language
                });
            }

           
            document.getElementById('textCounter').textContent = 250;
            
            this.setState({text: ''})

        }
    }
    changeHandler(event) {
        const value = event.target.value;

        if(typeof value === 'undefined') return;

        this.setState({
            text: value
        })
    }

    inputHandler(element){
        const defaultLenght = 250;
        let counterElement = document.getElementById('textCounter');
        const newValue = defaultLenght-parseInt(element.target.value.length);

        if(newValue < 40){
            counterElement.style.color = 'red';
        } else if (newValue >= 40 && newValue <= 80) {
            counterElement.style.color = '#ff9100'; 
        }else {
            counterElement.style.color = 'green'; 
        }

        counterElement.textContent = newValue;
    }

    listenForKey(event) {
        if(event.key === 'Enter')
            return this.postUserText();
    }

    componentDidMount() {
        //capture os params da location parseando com o URLSearchParamsconst 
        const params = new URLSearchParams(this.props.location.search);
        localStorage.setItem('language',params.get('lang'));
        this.setState({
            language: params.get('lang')
        });

        //para pegar um valor da query faça assim
        const email = params.get('email'); //por exemplo
        if(email){
            postData({
                text: `init ${email}`,
                id: store.sessionId,
                language: params.get('lang')
            });
            setLocalStoregeSession(store.sessionId)
        }else{
            postData({
                text: `start`,
                id: store.sessionId,
                language: params.get('lang')
            });
            setLocalStoregeSession(store.sessionId)
        }
    } 

    render() {
    
       return (
            <div className="footer">
                <div className="footerFormArea">
                    <div className="inputWrapper">
                    <input className="footerInput" id="bar" name="say" maxLength="250"
                    disabled="disabled"
                    value={this.state.text}
                    placeholder="Diga alguma coisa..."
                    onChange={this.changeHandler.bind(this)}
                    onKeyPress={this.listenForKey.bind(this)}
                    onInput={this.inputHandler.bind(this)}
                    type="text"/>
                    <div className="footerInputCounter">/<span id="textCounter">250</span></div>
                    </div>
                    <button className="footerSendButton" onClick={this.postUserText.bind(this)}>Enviar</button>
                </div>
            </div>
        )
    }
}

export default observer(Footer);